/** PTZ corner preview width as % of the main patrol video stage width. */

export const PATROL_PTZ_PREVIEW_SHARE_DEFAULT = 25;
export const PATROL_PTZ_PREVIEW_SHARE_MIN = 10;
export const PATROL_PTZ_PREVIEW_SHARE_MAX = 90;

/** 16:9 rectangular PiP (matches settings copy and wankhede-360 layout). */
export const PATROL_PTZ_PREVIEW_ASPECT_W = 16;
export const PATROL_PTZ_PREVIEW_ASPECT_H = 9;

export const PATROL_PTZ_PREVIEW_MIN_WIDTH = 160;
export const PATROL_PTZ_PREVIEW_MIN_HEIGHT = 90;

const STAGE_INSET_PX = 32;

/**
 * @param {unknown} value
 * @returns {number}
 */
export function normalizePatrolPtzPreviewSharePct(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return PATROL_PTZ_PREVIEW_SHARE_DEFAULT;
  return Math.min(
    PATROL_PTZ_PREVIEW_SHARE_MAX,
    Math.max(PATROL_PTZ_PREVIEW_SHARE_MIN, Math.round(n)),
  );
}

/**
 * Height for a 16:9 PiP at the given width.
 * @param {number} width
 * @returns {number}
 */
export function patrolPtzPipHeightForWidth(width) {
  return Math.round(
    (width * PATROL_PTZ_PREVIEW_ASPECT_H) / PATROL_PTZ_PREVIEW_ASPECT_W,
  );
}

/**
 * Compute rectangular 16:9 PTZ PiP size from stage dimensions and user share %.
 * Width is `sharePct`% of the main video stage; height follows 16:9.
 *
 * @param {number} stageWidth
 * @param {number} stageHeight
 * @param {number} sharePct
 * @returns {{ width: number; height: number }}
 */
export function computePatrolPtzPreviewPx(stageWidth, stageHeight, sharePct) {
  const share = normalizePatrolPtzPreviewSharePct(sharePct) / 100;

  let width =
    stageWidth > 0
      ? Math.round(stageWidth * share)
      : Math.round(320 * share);

  if (stageWidth > 0) {
    const maxW = Math.max(
      PATROL_PTZ_PREVIEW_MIN_WIDTH,
      stageWidth - STAGE_INSET_PX,
    );
    width = Math.min(width, maxW);
  }
  width = Math.max(PATROL_PTZ_PREVIEW_MIN_WIDTH, width);

  let height = patrolPtzPipHeightForWidth(width);

  if (stageHeight > 0) {
    const maxH = Math.max(
      PATROL_PTZ_PREVIEW_MIN_HEIGHT,
      stageHeight - STAGE_INSET_PX,
    );
    if (height > maxH) {
      height = maxH;
      width = Math.round(
        (height * PATROL_PTZ_PREVIEW_ASPECT_W) / PATROL_PTZ_PREVIEW_ASPECT_H,
      );
      width = Math.max(PATROL_PTZ_PREVIEW_MIN_WIDTH, width);
      height = patrolPtzPipHeightForWidth(width);
    }
  }

  return { width, height };
}
